import { render, staticRenderFns } from "./CheckboxBlank.vue?vue&type=template&id=01d20fc7&"
import script from "./CheckboxBlank.vue?vue&type=script&lang=js&"
export * from "./CheckboxBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports